// French (Français)
export default {
  nav: {
    home: 'Accueil',
    wall: 'Le Mur',
    groups: 'Groupes',
    users: 'Utilisateurs',
    profile: 'Mon profil',
    help: 'Aide',
    membership: 'Adhésion',
    logout: 'Déconnexion',
    login: 'Connexion'
  },
  auth: {
    loginSubtitle: 'Connectez-vous pour continuer',
    email: 'E-mail',
    password: 'Mot de passe',
    noAccount: "Vous n'avez pas de compte ?",
    createAccount: 'Créer un compte',
    loginFailed: 'Échec de la connexion. Vérifiez votre e-mail et mot de passe.',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    register: "S'inscrire",
    name: 'Nom',
    confirmPassword: 'Confirmer le mot de passe',
    registrationSuccess: 'Compte créé ! Vous pouvez maintenant vous connecter.',
    registrationFailed: 'Impossible de créer le compte.'
  },
  home: {
    title: 'Communauté',
    tagline: 'Un endroit calme sur internet – sans publicité.',
    description: 'Partagez le quotidien avec votre famille, vos amis et de nouvelles connaissances. Pas de bruit, pas de traçage, pas de vente de données.',
    features: {
      noAds: 'Sans publicité',
      simple: 'Simple et clair',
      safe: 'Ambiance sûre + modération'
    },
    cta: {
      openWall: 'Ouvrir le Mur',
      createProfile: 'Créer un profil gratuit',
      goToWall: 'Aller au Mur',
      readMore: "En savoir plus sur l'idée"
    },
    pricing: 'Le site est gratuit.',
    pricingDetail: 'Mais nous aussi devons vivre – merci de considérer un don.'
  },
  wall: {
    title: 'Le Mur',
    subtitle: 'Ici vous voyez les publications de la communauté.',
    writePost: 'ÉCRIRE SUR LE MUR',
    placeholder: 'Écrivez votre publication ici...',
    group: 'Groupe',
    noGroup: 'Aucun groupe',
    selectImage: 'Choisir une image',
    noFileSelected: 'Aucun fichier sélectionné.',
    send: 'Publier',
    public: 'Public',
    members: 'Membres',
    private: 'Privé',
    visibility: 'Visibilité'
  },
  groups: {
    title: 'Groupes',
    subtitle: 'Des groupes qui ont du sens – local, loisirs, voyages, promenades – faciles à suivre.',
    createGroup: 'Créer un groupe',
    allGroups: 'Tous les groupes',
    myGroups: 'Mes groupes',
    searchPlaceholder: 'Rechercher des groupes...',
    noGroups: 'Aucun groupe trouvé',
    noMyGroups: "Vous n'êtes encore membre d'aucun groupe",
    groupName: 'Nom du groupe',
    description: 'Description',
    publicGroup: 'Groupe public (tout le monde peut voir et rejoindre)',
    private: 'Privé',
    createdBy: 'Créé par',
    members: 'membres',
    postsCount: 'publications',
    noDescription: 'Aucune description',
    join: 'Rejoindre',
    leave: 'Quitter',
    open: 'Ouvrir',
    leaveConfirm: 'Êtes-vous sûr de vouloir quitter ce groupe ?',
    postsTab: 'Publications',
    membersTab: 'Membres',
    noPosts: 'Aucune publication dans ce groupe pour le moment',
    joinToSee: 'Rejoignez le groupe pour voir les publications',
    about: 'À propos',
    createdOn: 'Créé le',
    editGroup: 'Modifier le groupe',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce groupe ? Toutes les publications seront supprimées.',
    setMember: 'Définir comme membre',
    setModerator: 'Définir comme modérateur',
    setAdmin: 'Définir comme admin',
    removeMember: 'Retirer du groupe',
    removeMemberConfirm: 'Êtes-vous sûr de vouloir retirer {name} du groupe ?',
    changeCover: "Changer l'image de couverture",
    invalidImageType: 'Type de fichier invalide. Veuillez sélectionner une image.',
    imageTooLarge: "L'image est trop grande. Maximum 5 Mo."
  },
  profile: {
    title: 'Mon profil',
    editProfile: 'Modifier le profil',
    myPosts: 'Mes publications',
    myGroups: 'Mes groupes',
    overview: 'Aperçu',
    edit: 'Modifier',
    settings: 'Paramètres',
    activity: 'Activité',
    bio: 'À propos de moi',
    location: 'Localisation',
    website: 'Site web',
    birthday: 'Anniversaire',
    interests: 'Intérêts',
    joined: 'Inscrit le',
    posts: 'Publications',
    comments: 'Commentaires',
    reactions: 'Réactions',
    privacy: 'Confidentialité',
    showRealName: 'Afficher le vrai nom publiquement',
    showEmail: "Afficher l'e-mail publiquement",
    emailNotifications: 'Notifications par e-mail',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    uploadAvatar: 'Télécharger une photo de profil',
    changeAvatar: 'Changer la photo de profil',
    removeAvatar: 'Supprimer la photo de profil',
    bioPlaceholder: 'Parlez-nous de vous...',
    interestsPlaceholder: "Qu'est-ce qui vous intéresse ?",
    saveChanges: 'Enregistrer les modifications',
    cancelChanges: 'Annuler',
    profileUpdated: 'Profil mis à jour !',
    passwordChanged: 'Mot de passe changé !',
    avatarUploaded: 'Photo de profil téléchargée !',
    recentPosts: 'Publications récentes',
    recentComments: 'Commentaires récents',
    recentReactions: 'Réactions récentes',
    noPosts: 'Aucune publication pour le moment',
    noComments: 'Aucun commentaire pour le moment',
    noReactions: 'Aucune réaction pour le moment',
    downloadData: 'Télécharger mes données',
    deleteAccount: 'Supprimer le compte',
    deleteAccountWarning: 'Cela supprimera définitivement votre compte et toutes vos données. Cette action est irréversible.',
    age: 'ans'
  },
  common: {
    loading: 'Chargement...',
    error: 'Une erreur est survenue',
    success: 'Succès !',
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    post: 'Publier',
    comment: 'Commentaire',
    quote: 'Citer',
    reply: 'Répondre',
    confirm: 'Confirmer',
    ok: 'OK',
    data: 'Données',
    noComments: 'Aucun commentaire pour le moment. Soyez le premier !',
    writeComment: 'Écrire un commentaire...',
    replyToComment: 'Répondre au commentaire...',
    deleteConfirm: 'Supprimer cette publication ?',
    contentRequired: 'Le contenu ne peut pas être vide',
    updateFailed: 'Échec de la mise à jour de la publication',
    deleteFailed: 'Échec de la suppression de la publication',
    commentFailed: "Échec de l'envoi du commentaire"
  },
  users: {
    searchTitle: 'Trouver des utilisateurs',
    searchSubtitle: 'Rechercher des utilisateurs dans la communauté',
    searchPlaceholder: 'Rechercher par nom d utilisateur, nom ou e-mail...',
    search: 'Rechercher',
    searchHint: 'Entrez au moins 2 caractères pour rechercher des utilisateurs',
    resultsFound: '{count} utilisateur(s) trouvé(s)',
    noResults: 'Aucun utilisateur trouvé. Essayez un autre terme de recherche.'
  },
  validation: {
    required: 'Ce champ est requis',
    email: 'Entrez une adresse e-mail valide',
    maxLength: 'Maximum {max} caractères',
    passwordMatch: 'Les mots de passe doivent correspondre'
  }
}
